// Attention-model FOUNDATION (PURE, dependency-free). Spec §9: attention is the one
// primitive; focus is any act that moves Cipher's gaze, across mouse / keyboard / search
// / conversation / (future) voice+eye. This is the modality-agnostic plumbing that all
// later milestones plug their inputs into.
//
// M1 SCOPE: build the architecture; surface NO interactions. LivingCanvas instantiates
// the model but wires no input handlers — the resting canvas has zero affordances.

export const ATTENTION_VERBS = {
  REVEAL: "REVEAL",   // Cipher directs your attention (a node brightens because it learned something)
  FOCUS: "FOCUS",     // you commit attention (any modality)
  SUSTAIN: "SUSTAIN", // the thought stays manifested while attended
  RELEASE: "RELEASE", // attention moves on; manifestation recedes
};

export const MODALITIES = ["mouse", "keyboard", "search", "conversation", "voice", "eye", "system"];

export function makeAttentionModel(overrides = {}) {
  return {
    focusId: null,     // the thought currently attended (any modality)
    revealedId: null,  // a thought Cipher is directing you toward (reveal)
    source: null,      // which modality moved attention
    sustained: false,  // is the current focus being held
    history: [],       // recent attention path (for ghost trails, later)
    ...overrides,
  };
}

export function attentionReducer(state, action) {
  switch (action && action.type) {
    case ATTENTION_VERBS.FOCUS:
      return {
        ...state,
        focusId: action.id || null,
        source: action.source || "system",
        sustained: false,
        revealedId: null,
        history: action.id ? [...state.history, action.id].slice(-8) : state.history,
      };
    case ATTENTION_VERBS.REVEAL:
      // Cipher directs attention; does NOT commit focus (§9 "Cipher reveals").
      return { ...state, revealedId: action.id || null, source: "system" };
    case ATTENTION_VERBS.SUSTAIN:
      return { ...state, sustained: true };
    case ATTENTION_VERBS.RELEASE:
      return { ...state, focusId: null, revealedId: null, sustained: false, source: action && action.source ? action.source : state.source };
    default:
      return state;
  }
}

// A thought is "attended" if focused or being revealed.
export function isAttended(state, nodeId) {
  return !!state && (state.focusId === nodeId || state.revealedId === nodeId);
}
